import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import { DigiAlertPopupComponent } from '../digi-alert-popup/digi-alert-popup.component';
import { DigiReportPopupComponent } from '../digi-report-popup/digi-report-popup.component';
import { DigiAnalysisComponent } from '../digi-analysis/digi-analysis.component';
import { Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
var DigiMonitoringComponent = /** @class */ (function () {
    function DigiMonitoringComponent(digiService, dialog, ngxLoader) {
        this.digiService = digiService;
        this.dialog = dialog;
        this.ngxLoader = ngxLoader;
        // Math reference for template
        this.Math = Math;
        // Selected device (object with deviceid, digiid, sitename)
        this.selectedDevice = null;
        // Data & info
        this.currentData = null;
        this.generatorInfo = null;
        this.generatorIds = [];
        // Metrics
        this.metrics = {
            KWH: 0,
            KVAH: 0,
            KVARH: 0,
            PF: 0,
            runningHours: 0,
            energyEfficiency: 0,
            loadFactor: 0,
            fuelRatePerKWh: 0,
            totalFuel: 0,
            fuelUnitPrice: 0
        };
        // Totals for analytics tab
        this.totalGenerators = 0;
        this.onlineGenerators = 0;
        this.offlineGenerators = 0;
        this.alertGenerators = 0;
        this.totalAlerts = 0;
        this.activeWarnings = 0;
        // Filters
        this.timeOptions = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
        this.timeFilter = 'Today'; // used by HTML analytics tab
        this.selectedDuration = 'Today'; // used by logic / live tab
        this.customeSelectedDate = null;
        this.selectedFilter = null;
        // status & flags
        this.connectionStatus = 'connected';
        this.lastUpdate = new Date();
        this.lastStart = new Date();
        this.isData = false;
        // Oil gauge config
        this.oilTempMin = 0;
        this.oilTempMax = 100;
        this.oilGaugeCircumference = Math.PI * 80; // used in template
        // timers / subscriptions
        this.connectionTimer = null;
        this.subs = new Subscription();
        // current user
        this.currentUserData = JSON.parse(localStorage.getItem('userData') || '{}');
        this.deviceStatus = { "online": 0, "offline": 0 };
    }
    DigiMonitoringComponent.prototype.ngOnInit = function () {
        this.getDigiIds();
        this.startConnectionSimulation();
    };
    DigiMonitoringComponent.prototype.ngOnDestroy = function () {
        this.stopAllTimers();
        this.subs.unsubscribe();
    };
    // ---------------------------
    // Helpers to replace ?. and ??
    // ---------------------------
    /**
     * Return first non-null/undefined value among possible keys of an object.
     * Example: getAny(obj, ['KWH','kwh'], 0)
     */
    DigiMonitoringComponent.prototype.getAny = function (obj, keys, defaultValue) {
        if (!obj)
            return defaultValue;
        for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            if (obj[k] !== undefined && obj[k] !== null) {
                return obj[k];
            }
        }
        return defaultValue;
    };
    /**
     * Safe access: returns obj[prop] if obj exists and prop is not null/undefined else defaultVal
     */
    DigiMonitoringComponent.prototype.safe = function (obj, prop, defaultVal) {
        if (!obj)
            return defaultVal;
        var v = obj[prop];
        return (v !== undefined && v !== null) ? v : defaultVal;
    };
    DigiMonitoringComponent.prototype.getSelectedDeviceId = function () {
        return (this.selectedDevice && this.selectedDevice.deviceid) ? this.selectedDevice.deviceid : null;
    };
    // ===========================
    // Data fetching methods
    // ===========================
    DigiMonitoringComponent.prototype.getDigiIds = function () {
        var _this = this;
        if (!this.currentUserData || !this.currentUserData.userid) {
            // fallback - no user info
            this.generatorIds = [];
            this.updateTotals();
            return;
        }
        var s = this.digiService.getDigiIds({ userid: this.currentUserData.userid })
            .pipe(catchError(function (err) {
            console.error('getDigiIds error', err);
            return of({ status: false, result: [] });
        }))
            .subscribe(function (resp) {
            if (resp && resp.status && Array.isArray(resp.result)) {
                _this.generatorIds = resp.result;
                _this.totalGenerators = _this.generatorIds.length;
                _this.getGeneratorsStatus(_this.generatorIds);
                // try to derive status if available inside description JSON (best-effort)
                _this.deriveDeviceStatuses();
                // select first device by default
                if (_this.generatorIds.length > 0) {
                    _this.selectedDevice = _this.generatorIds[0];
                    _this.onDeviceSelect(_this.selectedDevice);
                }
                else {
                    _this.selectedDevice = null;
                    _this.currentData = null;
                    _this.isData = false;
                }
            }
            else {
                _this.generatorIds = [];
                _this.updateTotals();
            }
        });
        this.subs.add(s);
    };
    DigiMonitoringComponent.prototype.getGeneratorsStatus = function (generatorsIds) {
        var _this = this;
        console.log("asjdhasjdsa", generatorsIds);
        this.digiService.getDeviceStatus(generatorsIds).subscribe(function (res) {
            if (res.status) {
                console.log("online devices", res.result);
                _this.deviceStatus.offline = generatorsIds.length - res.result.length;
                _this.deviceStatus.onliine = res.result.length;
            }
            else {
                _this.deviceStatus.offline = generatorsIds.length;
            }
        });
    };
    // Best-effort: derive counts from description JSON if present.
    DigiMonitoringComponent.prototype.deriveDeviceStatuses = function () {
        var online = 0, offline = 0, alert = 0;
        for (var i = 0; i < this.generatorIds.length; i++) {
            var d = this.generatorIds[i];
            try {
                if (d && d.description) {
                    var desc = (typeof d.description === 'string') ? JSON.parse(d.description) : d.description;
                    var st = (desc && desc.status) ? (desc.status + '').toLowerCase() : null;
                    if (st === 'online')
                        online++;
                    else if (st === 'offline')
                        offline++;
                    else if (st === 'alert' || st === 'warning')
                        alert++;
                    else
                        online++; // unknown treated as online
                }
                else {
                    online++;
                }
            }
            catch (err) {
                online++;
            }
        }
        this.onlineGenerators = online;
        this.offlineGenerators = offline;
        this.alertGenerators = alert;
    };
    DigiMonitoringComponent.prototype.getDeviceInfo = function (deviceid) {
        var _this = this;
        if (!deviceid)
            return;
        var s = this.digiService.getGeneratorByDeviceid({ deviceid: deviceid })
            .pipe(catchError(function (err) {
            console.error('getGeneratorByDeviceid error', err);
            return of({ status: false });
        }))
            .subscribe(function (res) {
            if (res && res.status) {
                _this.generatorInfo = res.result;
            }
            else {
                _this.generatorInfo = null;
            }
        });
        this.subs.add(s);
    };
    DigiMonitoringComponent.prototype.getData = function (deviceObject) {
        var _this = this;
        if (!deviceObject || !deviceObject.deviceid)
            return;
        var s = this.digiService.getDigiLastData({ deviceid: deviceObject.deviceid })
            .pipe(catchError(function (err) {
            console.error('getDigiLastData error', err);
            return of({ status: false });
        }))
            .subscribe(function (res) {
            if (res && res.status && res.result && res.result.length) {
                // result[0].readings is JSON string
                try {
                    _this.currentData = JSON.parse(res.result[0].readings);
                }
                catch (err) {
                    _this.currentData = res.result[0].readings;
                }
                // attach metadata if present
                _this.currentData.insertedDate = res.result[0].insertedDate || _this.currentData.Date || new Date().toISOString();
                // set defaults if missing keys used by template -- using getAny helper
                _this.currentData.Fuel_Level = _this.getAny(_this.currentData, ['Fuel_Level', 'fuelLevel'], 0);
                _this.currentData.refuelAt = _this.getAny(_this.currentData, ['refuelAt'], 20);
                _this.currentData.RPM = _this.getAny(_this.currentData, ['RPM', 'rpm'], 0);
                _this.currentData.Oil_Temp = _this.getAny(_this.currentData, ['Oil_Temp', 'oilTemp'], 0);
                _this.currentData.L1_Voltage = _this.getAny(_this.currentData, ['L1_Voltage', 'l1Voltage'], 0);
                _this.currentData.L2_Voltage = _this.getAny(_this.currentData, ['L2_Voltage', 'l2Voltage'], 0);
                _this.currentData.L3_Voltage = _this.getAny(_this.currentData, ['L3_Voltage', 'l3Voltage'], 0);
                _this.currentData.L1L2_Voltage = _this.getAny(_this.currentData, ['L1L2_Voltage', 'l1l2Voltage'], 0);
                _this.currentData.L2L3_Voltage = _this.getAny(_this.currentData, ['L2L3_Voltage', 'l2l3Voltage'], 0);
                _this.currentData.L3L1_Voltage = _this.getAny(_this.currentData, ['L3L1_Voltage', 'l3l1Voltage'], 0);
                _this.currentData.L1_Current = _this.getAny(_this.currentData, ['L1_Current', 'l1Current'], 0);
                _this.currentData.L2_Current = _this.getAny(_this.currentData, ['L2_Current', 'l2Current'], 0);
                _this.currentData.L3_Current = _this.getAny(_this.currentData, ['L3_Current', 'l3Current'], 0);
                _this.currentData.PF = _this.getAny(_this.currentData, ['PF', 'powerFactor'], 1);
                _this.currentData.Total_KW = _this.getAny(_this.currentData, ['Total_KW', 'totalKW'], 0);
                _this.currentData.Total_KVA = _this.getAny(_this.currentData, ['Total_KVA', 'totalKVA'], 0);
                _this.currentData.Total_KVAR = _this.getAny(_this.currentData, ['Total_KVAR', 'totalKVAR'], 0);
                _this.currentData.KWH = _this.getAny(_this.currentData, ['KWH', 'kwh'], 0);
                _this.currentData.KVARH = _this.getAny(_this.currentData, ['KVARH', 'kvarh'], 0);
                _this.currentData.KVAH = _this.getAny(_this.currentData, ['KVAH', 'kvah'], 0);
                _this.isData = true;
                // update device status based on currentData thresholds
                _this.updateDeviceStatus();
            }
            else {
                _this.currentData = null;
                _this.isData = false;
            }
        });
        this.subs.add(s);
    };
    // ===========================
    // UI handlers (selection & filter)
    // ===========================
    // Called from template when device is selected
    DigiMonitoringComponent.prototype.onDeviceSelect = function (device) {
        // template may pass event.value or nothing; allow both
        var dev = (device !== undefined && device !== null) ? device : this.selectedDevice;
        if (!dev)
            return;
        this.selectedDevice = dev;
        this.getDeviceInfo(dev.deviceid);
        this.getData(dev);
        // maintain the currently selected duration
        var tf = (this.selectedDuration !== undefined && this.selectedDuration !== null) ? this.selectedDuration : this.timeFilter;
        tf = (tf !== undefined && tf !== null) ? tf : 'Today';
        this.filters(tf);
    };
    // filters() is used by your HTML (analytics tab) and Live Data section
    DigiMonitoringComponent.prototype.filters = function (duration) {
        var _this = this;
        this.selectedDuration = duration;
        // precompute device id safe
        var deviceid = this.getSelectedDeviceId();
        // If custom open dialog
        if (duration === 'Custom') {
            var dialogRef = this.dialog.open(CustomDateComponent, {
                autoFocus: false,
                height: '350px',
                width: '450px',
                data: { details: '', action: 'Add', selectedDate: this.customeSelectedDate }
            });
            dialogRef.afterClosed().subscribe(function (value) {
                if (value) {
                    // Object spread is fine in TS 3.5; if you face issues replace with Object.assign
                    _this.selectedFilter = Object.assign({}, value, { duration: duration, deviceid: deviceid });
                    _this.customeSelectedDate = value;
                }
                else {
                    // user closed without selecting — keep previous filter
                    _this.selectedFilter = { duration: duration, deviceid: deviceid };
                }
                if (_this.selectedFilter && _this.selectedDevice) {
                    _this.getReportData(_this.selectedFilter);
                    // pass deviceid (safe)
                    if (deviceid)
                        _this.getDeviceInfo(deviceid);
                }
            });
        }
        else {
            this.selectedFilter = { duration: duration, deviceid: deviceid };
            if (this.selectedFilter && this.selectedDevice) {
                this.getReportData(this.selectedFilter);
                if (deviceid)
                    this.getDeviceInfo(deviceid);
            }
        }
    };
    // ===========================
    // Report & metrics logic
    // ===========================
    DigiMonitoringComponent.prototype.getReportData = function (filter) {
        var _this = this;
        if (!filter || !filter.deviceid)
            return;
        this.ngxLoader.startLoader('analytics');
        var s = this.digiService.getReportData(filter)
            .pipe(catchError(function (err) {
            console.error('getReportData error', err);
            return of({ status: false });
        }))
            .subscribe(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var data, first, last, kwh, kvah, kvarh, _a, _b, _c, err_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(res && res.status && Array.isArray(res.result) && res.result.length > 1)) return [3 /*break*/, 7];
                        data = res.result;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 5, , 6]);
                        first = data[0];
                        last = data[data.length - 1];
                        kwh = Number(this.getAny(last, ['KWH', 'kwh'], 0)) - Number(this.getAny(first, ['KWH', 'kwh'], 0));
                        kvah = Number(this.getAny(last, ['KVAH', 'kvah'], 0)) - Number(this.getAny(first, ['KVAH', 'kvah'], 0));
                        kvarh = Number(this.getAny(last, ['KVARH', 'kvarh'], 0)) - Number(this.getAny(first, ['KVARH', 'kvarh'], 0));
                        this.metrics.KWH = Number(kwh.toFixed(2));
                        this.metrics.KVAH = Number(kvah.toFixed(2));
                        this.metrics.KVARH = Number(kvarh.toFixed(2));
                        this.metrics.energyEfficiency = (this.metrics.KVAH ? Number((this.metrics.KWH / this.metrics.KVAH).toFixed(2)) : 0);
                        _a = this.metrics;
                        return [4 /*yield*/, this.calculateRunningHours(data)];
                    case 2:
                        _a.runningHours = _d.sent();
                        _b = this.metrics;
                        return [4 /*yield*/, this.calculateLoadFactor(data)];
                    case 3:
                        _b.loadFactor = _d.sent();
                        _c = this;
                        return [4 /*yield*/, this.calculateFuelMetrics(data, this.generatorInfo.fuelTankCapacity, this.metrics.KVAH, Number(this.generatorInfo.fuelPrice))];
                    case 4:
                        _c.fuelDataObject = _d.sent();
                        this.ngxLoader.stopLoader('analytics');
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _d.sent();
                        this.ngxLoader.stopLoader('analytics');
                        console.error('calc metrics error', err_1);
                        this.resetMetrics();
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        this.ngxLoader.stopLoader('analytics');
                        this.resetMetrics();
                        _d.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        }); });
        this.subs.add(s);
    };
    DigiMonitoringComponent.prototype.resetMetrics = function () {
        this.metrics = {
            KWH: 0,
            KVAH: 0,
            KVARH: 0,
            PF: 0,
            runningHours: 0,
            energyEfficiency: 0,
            loadFactor: 0,
            fuelRatePerKWh: 0,
            totalFuel: 0,
            fuelUnitPrice: 0
        };
    };
    DigiMonitoringComponent.prototype.calculateFuelMetrics = function (fuelData, tankCapacity, energyGeneratedKWh, fuelRatePerLitre) {
        if (fuelData.length < 2 || tankCapacity <= 0) {
            return { fuelUsedPercent: 0, fuelUsedLitres: 0, fuelPerKWh: 0, fuelCost: 0, refillCount: 0, kwhperliter: 0 };
        }
        // Sort by time ascending (safety)
        //fuelData.sort((a, b) => new Date(a.insertedDate).getTime() - new Date(b.insertedDate).getTime());
        console.log("asasdasdasdwad", tankCapacity);
        var totalFuelUsedPercent = 0;
        var refillCount = 0;
        // Start baseline as first reading
        var lastLevel = Number(fuelData[0].Fuel_Level);
        if (Number.isNaN(lastLevel))
            lastLevel = 0;
        // tolerance to ignore tiny jitter (e.g., 0.2% noise). Adjust as needed.
        var TOLERANCE = 0.2;
        for (var i = 1; i < fuelData.length; i++) {
            var currentLevelRaw = Number(fuelData[i].Fuel_Level);
            if (Number.isNaN(currentLevelRaw)) {
                // skip invalid reading
                continue;
            }
            console.log("fuelData[i].Fuel_Level", fuelData[i].Fuel_Level);
            var currentLevel = currentLevelRaw;
            var diff = lastLevel - currentLevel;
            if (diff > TOLERANCE) {
                // genuine consumption
                totalFuelUsedPercent += diff;
                lastLevel = currentLevel; // move baseline forward
            }
            else if (currentLevel - lastLevel > 2) {
                // level increased => refill (or sensor jump). Treat as refill: don't add consumption.
                refillCount++;
                lastLevel = currentLevel; // reset baseline to the new higher value
            }
            else {
                // difference within tolerance => noise; ignore and keep lastLevel unchanged or set to current
                // set to current so we follow small trends (optional)
                lastLevel = currentLevel;
            }
        }
        // Convert percent used -> litres
        var fuelUsedLitres = (totalFuelUsedPercent / 100) * tankCapacity;
        // fuel per kWh and cost
        var fuelPerKWh = energyGeneratedKWh > 0 ? fuelUsedLitres / energyGeneratedKWh : 0;
        var fuelCost = fuelUsedLitres * fuelRatePerLitre;
        var kwhperliter = 0;
        if (fuelUsedLitres != 0) {
            kwhperliter = Number(energyGeneratedKWh / fuelUsedLitres).toFixed(2);
        }
        return {
            fuelUsedPercent: Number(totalFuelUsedPercent.toFixed(2)),
            fuelUsedLitres: Number(fuelUsedLitres.toFixed(2)),
            fuelPerKWh: Number(fuelPerKWh.toFixed(4)),
            fuelCost: Number(fuelCost.toFixed(2)),
            kwhperliter: kwhperliter,
            refillCount: refillCount
        };
    };
    // ===========================
    // Calculations used in template
    // ===========================
    DigiMonitoringComponent.prototype.calculateLoadFactor = function (data) {
        var _this = this;
        if (!data || data.length === 0 || !this.generatorInfo.capacity)
            return 0;
        // Helper to safely get numeric average for a key
        var avg = function (key) {
            var values = data
                .map(function (d) { return Number(_this.getAny(d, [key], 0)); })
                .filter(function (v) { return !isNaN(v); });
            if (values.length === 0)
                return 0;
            return values.reduce(function (a, b) { return a + b; }, 0) / values.length;
        };
        // ✅ Compute averages
        var Vavg = (avg('L1L2_Voltage') + avg('L2L3_Voltage') + avg('L3L1_Voltage')) / 3;
        var Iavg = (avg('L1_Current') + avg('L2_Current') + avg('L3_Current')) / 3;
        var PFavg = Math.abs(avg('PF'));
        console.log('Averages → Vavg:', Vavg, 'Iavg:', Iavg, 'PF:', PFavg);
        // ✅ Compute total power in kW
        var PtotalKW = (Math.sqrt(3) * Vavg * Iavg * PFavg) / 1000;
        // ✅ Load factor calculation
        var capacity = Number(this.generatorInfo.capacity);
        if (!capacity || capacity === 0)
            return 0;
        var loadFactor = PtotalKW / capacity;
        return Number(isFinite(loadFactor) ? loadFactor.toFixed(2) : 0);
    };
    DigiMonitoringComponent.prototype.calculateRunningHours = function (data) {
        if (!Array.isArray(data) || data.length === 0)
            return 0;
        var sorted = data.slice().sort(function (a, b) { return new Date(a.Date).getTime() - new Date(b.Date).getTime(); });
        var totalMinutes = 0;
        for (var i = 1; i < sorted.length; i++) {
            var prev = sorted[i - 1];
            var curr = sorted[i];
            var diffMs = new Date(curr.Date).getTime() - new Date(prev.Date).getTime();
            var diffMinutes = diffMs / (1000 * 60);
            var prevRunning = Number(this.getAny(prev, ['Total_KW', 'TotalKW', 'Total_KW'], 0)) > 0;
            var currRunning = Number(this.getAny(curr, ['Total_KW', 'TotalKW', 'Total_KW'], 0)) > 0;
            // as per original logic — counting gaps up to 20 minutes
            if (prevRunning && currRunning && diffMinutes <= 20) {
                totalMinutes += diffMinutes;
            }
        }
        var time = Number((totalMinutes / 60).toFixed(2));
        if (time > 15 && (this.selectedDuration == "Today" || this.selectedDuration == "Yesterday")) {
            this.utilizationStatus = "Overutilized";
        }
        else if (time < 1 && (this.selectedDuration == "Today" || this.selectedDuration == "Yesterday")) {
            this.utilizationStatus = "Underutilized";
        }
        else if (this.selectedDuration == "Today" || this.selectedDuration == "Yesterday") {
            this.utilizationStatus = "Optimal";
        }
        if (time > 80 && this.selectedDuration == "This Week") {
            this.utilizationStatus = "Overutilized";
        }
        else if (time < 5 && this.selectedDuration == "This Week") {
            this.utilizationStatus = "Underutilized";
        }
        else if (this.selectedDuration == "This Week") {
            this.utilizationStatus = "Optimal";
        }
        if (time > 200 && (this.selectedDuration == "This Month" || this.selectedDuration == "Last Month")) {
            this.utilizationStatus = "Overutilized";
        }
        else if (time < 10 && (this.selectedDuration == "This Month" || this.selectedDuration == "Last Month")) {
            this.utilizationStatus = "Underutilized";
        }
        else if (this.selectedDuration == "This Month" || this.selectedDuration == "Last Month") {
            this.utilizationStatus = "Optimal";
        }
        return Number((totalMinutes / 60).toFixed(2));
    };
    // ===========================
    // Helper visual / status methods (used by HTML)
    // ===========================
    DigiMonitoringComponent.prototype.getFuelGaugeHeight = function () {
        var val = Number(this.getAny(this.currentData, ['Fuel_Level'], 0));
        return Math.max(2, Math.min(98, val));
    };
    DigiMonitoringComponent.prototype.getFuelColorClass = function () {
        var val = Number(this.getAny(this.currentData, ['Fuel_Level'], 0));
        if (val > 50)
            return 'fuel-high';
        if (val > 30)
            return 'fuel-medium';
        return 'fuel-low';
    };
    DigiMonitoringComponent.prototype.shouldShowRefuelWarning = function () {
        var level = Number(this.getAny(this.currentData, ['Fuel_Level'], 0));
        var refAt = Number(this.getAny(this.currentData, ['refuelAt'], 20));
        return level <= refAt;
    };
    DigiMonitoringComponent.prototype.getRPMDashOffset = function () {
        var minRPM = 500;
        var maxRPM = 2000;
        var rpm = Number(this.getAny(this.currentData, ['RPM', 'RPM'], 0));
        var percentage = Math.max(0, Math.min(1, (rpm - minRPM) / (maxRPM - minRPM)));
        var full = 534; // same as template stroke-dasharray
        return full - (full * percentage);
    };
    DigiMonitoringComponent.prototype.getVoltageStatus = function (voltage, type) {
        if (voltage == null || isNaN(voltage))
            return 'normal';
        var min = 0, max = 999;
        switch (type) {
            case 'l1':
            case 'l3':
                min = 55;
                max = 65;
                break;
            case 'l2':
                min = 24;
                max = 28;
                break;
            case 'l1l2':
            case 'l3l1':
                min = 28;
                max = 32;
                break;
            case 'l2l3':
                min = 4;
                max = 6;
                break;
            default:
                min = 0;
                max = 999;
        }
        if (voltage < min || voltage > max)
            return 'critical';
        if (voltage < min * 1.05 || voltage > max * 0.95)
            return 'warning';
        return 'normal';
    };
    DigiMonitoringComponent.prototype.getCurrentStatus = function (current) {
        if (current == null || isNaN(current))
            return 'normal';
        if (current > 30)
            return 'high';
        if (current < 2)
            return 'low';
        return 'normal';
    };
    DigiMonitoringComponent.prototype.getOilTempStatus = function () {
        var val = Number(this.getAny(this.currentData, ['Oil_Temp'], 0));
        if (val > 95)
            return 'critical';
        if (val > 90)
            return 'warning';
        if (val < 60)
            return 'low';
        return 'normal';
    };
    DigiMonitoringComponent.prototype.getOilTempDashOffset = function () {
        var value = Math.max(this.oilTempMin, Math.min(this.oilTempMax, Number(this.getAny(this.currentData, ['Oil_Temp'], 0))));
        var percentage = (value - this.oilTempMin) / (this.oilTempMax - this.oilTempMin);
        return this.oilGaugeCircumference * (1 - percentage);
    };
    DigiMonitoringComponent.prototype.getPowerFactorStatus = function () {
        var pf = Number(this.getAny(this.currentData, ['PF'], 1));
        if (pf < 0.7)
            return 'low';
        if (pf < 0.8)
            return 'warning';
        return 'normal';
    };
    DigiMonitoringComponent.prototype.getConnectionStatusText = function () {
        switch (this.connectionStatus) {
            case 'connected': return 'Connected';
            case 'disconnected': return 'Disconnected';
            case 'syncing': return 'Syncing...';
            default: return 'Unknown';
        }
    };
    DigiMonitoringComponent.prototype.formatDate = function (date) {
        if (!date)
            return 'N/A';
        try {
            var d = new Date(date);
            return d.toLocaleString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        catch (err) {
            return String(date);
        }
    };
    DigiMonitoringComponent.prototype.getParameterStatus = function (parameter, value) {
        switch (parameter) {
            case 'fuelLevel':
                if (value <= 15)
                    return 'critical';
                if (value <= 30)
                    return 'warning';
                return 'normal';
            case 'rpm':
                if (value > 1800 || value < 1000)
                    return 'critical';
                if (value > 1700 || value < 1200)
                    return 'warning';
                return 'normal';
            case 'oilTemp':
                return this.getOilTempStatus();
            case 'powerFactor':
                return this.getPowerFactorStatus();
            default:
                return 'normal';
        }
    };
    DigiMonitoringComponent.prototype.getSystemHealth = function () {
        var healthScore = 100;
        if (!this.currentData)
            return healthScore;
        if (this.currentData.status === 'alert')
            healthScore -= 30;
        else if (this.currentData.status === 'warning')
            healthScore -= 15;
        var fuel = Number(this.getAny(this.currentData, ['Fuel_Level'], 0));
        if (fuel < 20)
            healthScore -= 20;
        else if (fuel < 50)
            healthScore -= 10;
        var rpm = Number(this.getAny(this.currentData, ['RPM'], 0));
        if (rpm > 1700)
            healthScore -= 15;
        var oil = Number(this.getAny(this.currentData, ['Oil_Temp'], 0));
        if (oil > 90)
            healthScore -= 15;
        var pf = Number(this.getAny(this.currentData, ['PF'], 1));
        if (pf < 0.8)
            healthScore -= 10;
        return Math.max(0, Math.min(100, healthScore));
    };
    // imbalance & vunbalance helpers
    DigiMonitoringComponent.prototype.getInbalance = function (currentData) {
        var L1 = Number(this.getAny(currentData, ['L1_Current'], 0));
        var L2 = Number(this.getAny(currentData, ['L2_Current'], 0));
        var L3 = Number(this.getAny(currentData, ['L3_Current'], 0));
        var avg = (L1 + L2 + L3) / 3 || 1;
        var max = Math.max(L1, L2, L3);
        var min = Math.min(L1, L2, L3);
        var imbalancePercent = ((max - min) / avg) * 100;
        return {
            imbalancePercent: parseFloat(isFinite(imbalancePercent) ? imbalancePercent.toFixed(2) : '0'),
            status: imbalancePercent > 20 ? 'High Imbalance' : 'Normal'
        };
    };
    DigiMonitoringComponent.prototype.getVunbalance = function (currentData) {
        var L1 = Number(this.getAny(currentData, ['L1_Voltage'], 0));
        var L2 = Number(this.getAny(currentData, ['L2_Voltage'], 0));
        var L3 = Number(this.getAny(currentData, ['L3_Voltage'], 0));
        var avg = (L1 + L2 + L3) / 3 || 1;
        var deviations = [Math.abs(L1 - avg), Math.abs(L2 - avg), Math.abs(L3 - avg)];
        var maxDeviation = Math.max.apply(null, deviations);
        var vunbalancePercent = (maxDeviation / avg) * 100;
        return {
            vunbalancePercent: parseFloat(isFinite(vunbalancePercent) ? vunbalancePercent.toFixed(2) : '0'),
            status: vunbalancePercent > 2 ? 'High Unbalance' : 'Normal'
        };
    };
    // ===========================
    // Status simulation & timers
    // ===========================
    DigiMonitoringComponent.prototype.startConnectionSimulation = function () {
        var _this = this;
        this.connectionTimer = setInterval(function () {
            _this.simulateConnectionStatus();
        }, 30000);
    };
    DigiMonitoringComponent.prototype.stopAllTimers = function () {
        if (this.connectionTimer) {
            clearInterval(this.connectionTimer);
            this.connectionTimer = null;
        }
    };
    DigiMonitoringComponent.prototype.simulateConnectionStatus = function () {
        var _this = this;
        var random = Math.random();
        if (random > 0.9) {
            this.connectionStatus = 'disconnected';
            setTimeout(function () {
                _this.connectionStatus = 'syncing';
                setTimeout(function () {
                    _this.connectionStatus = 'connected';
                }, 2000);
            }, 3000);
        }
    };
    DigiMonitoringComponent.prototype.updateDeviceStatus = function () {
        if (!this.currentData)
            return;
        var fuel = Number(this.getAny(this.currentData, ['Fuel_Level'], 0));
        var rpm = Number(this.getAny(this.currentData, ['RPM'], 0));
        var l1 = Number(this.getAny(this.currentData, ['L1_Voltage'], 0));
        var oil = Number(this.getAny(this.currentData, ['Oil_Temp'], 0));
        if (fuel <= 10 || rpm > 1800 || l1 < 50 || l1 > 70 || oil > 95) {
            this.currentData.status = 'alert';
        }
        else if (fuel <= this.getAny(this.currentData, ['refuelAt'], 20) || rpm > 1650 || l1 < 55 || l1 > 65 || oil > 90) {
            this.currentData.status = 'warning';
        }
        else {
            this.currentData.status = 'online';
        }
    };
    // ===========================
    // Dialog / navigation helpers
    // ===========================
    DigiMonitoringComponent.prototype.goToAlerts = function () {
        this.dialog.open(DigiAlertPopupComponent, {
            width: '80%',
            height: '90%',
            data: { deviceId: this.selectedDevice }
        });
    };
    DigiMonitoringComponent.prototype.goToReports = function () {
        this.dialog.open(DigiReportPopupComponent, {
            width: '80%',
            height: '95%',
            data: { deviceData: this.currentData }
        });
    };
    DigiMonitoringComponent.prototype.goToAnalysis = function () {
        this.dialog.open(DigiAnalysisComponent, {
            width: '80%',
            height: '92%',
            data: { deviceData: this.currentData }
        });
    };
    // small util to update totals (fallback)
    DigiMonitoringComponent.prototype.updateTotals = function () {
        this.totalGenerators = this.generatorIds.length;
        // if no per-device status we assume they are online to avoid showing zeros
        this.onlineGenerators = this.generatorIds.length;
        this.offlineGenerators = 0;
        this.alertGenerators = 0;
    };
    return DigiMonitoringComponent;
}());
export { DigiMonitoringComponent };
